<td-wb-page-panel>
  @if (lesson !== undefined && lesson.title !== undefined) {
    <h1 class="td-wb-learn-lesson-content__title">
      <span translate="tdWb.learn.lesson.TITLE"></span>
      <span id="td-wb-aria-lesson-title-header" [innerText]="lesson.title"></span>
    </h1>
  }
</td-wb-page-panel>

<div class="td-wb-learn-lesson-content__grid"
     tdWbDataAnalyticsTagging
     [eventSignal]="eventData">
  <div class="td-wb-learn-lesson-content__grid-inner">
    <div class="td-wb-learn-lesson-content__grid-content-offset"></div>
    <div class="td-wb-learn-lesson-content__grid-content">
      @if (loadingIndicator) {
        <td-wb-learn-loading></td-wb-learn-loading>
      } @else {
        @if (lesson !== undefined) {
          <div class="td-wb-learn-lesson-content__info">
            <td-wb-learn-lesson-info [lesson]="lesson"></td-wb-learn-lesson-info>
            <div class="td-wb-learn-lesson-content__buttons">
              <button id="td-wb-learn-lesson-save"
                      class="td-wb-learn-lesson-content__save"
                      tdWbButton
                      tdWbButtonType="secondary"
                      tdWbBlock="spinningWheel"
                      [attr.aria-label]="((lesson.saved ? 'tdWb.learn.UNSAVE_LESSON' : 'tdWb.learn.SAVE_LESSON') | tdWbTranslate)"
                      [disabled]="saveDisabled"
                      (click)="toggleSave()">
                <td-wb-icon class="td-wb-learn-lesson-content__icon"
                            [iconId]="lesson.saved ? 'bookmark-solid--small' : 'bookmark-outlined--small'"
                            [inline]="true"
                            size="18"></td-wb-icon>
              </button>
              <button id="td-wb-learn-lesson-like"
                      class="td-wb-learn-lesson-content__like"
                      tdWbButton
                      tdWbButtonType="secondary"
                      tdWbBlock="spinningWheel"
                      (click)="toggleLike()"
                      aria-labelledby="td-wb-aria-like-button-label"
                      [disabled]="likeDisabled">
                @if (getLikeCount() === undefined) {
                  <span>&nbsp;</span>
                }
                <td-wb-icon [iconId]="getLike() ? 'like-solid--small' : 'like-outlined--small'"
                            [inline]="true"
                            size="18"></td-wb-icon>
                <span id="td-wb-aria-like-button-label">
                  <span class="td-wb-vh"><span
                    [translate]="(getLike() ? 'tdWb.learn.lesson.alt.UNLIKE' : 'tdWb.learn.lesson.alt.LIKE')"></span> - </span>
                  @if (getLikeCount() !== undefined) {
                    <span
                      class="td-wb-learn-lesson-content__like-label--text"
                      [innerText]="getLikeCount() | tdWbNumber: {format: 'n0', shorten: true, emptyPlaceholder: '&nbsp;'}">
                    </span>
                  }
                  <span class="td-wb-vh" translate="tdWb.learn.lesson.alt.TOTAL_LIKES"></span>
                </span>
              </button>
            </div>
          </div>
          <td-wb-learn-player class="td-wb-learn-lesson-content__player"
                              [section]="section"
                              [lesson]="lesson"
                              [lessonView]="true"></td-wb-learn-player>
        }
      }
    </div>
  </div>
</div>

